<template>
    <div>
        <SubmissionSuccessModalComponent />
    </div>
</template>

<script>

export default {
    name: "SubmissionSuccessPage",
    props: {},
    components: {
    },
    computed: {
    },
    data: function () {
        return {

        };
    },
    methods: {
    },
    mounted() {
        this.$gtm.trackView('Submission Success', 'currentPath');
    },
};
</script>
